import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import {
  MarketPriceEstimationData,
  AppraisalPointData,
  NumberOfFailedBidData,
  OldAgeData,
  SalesDaysData,
} from '../../../interface/aiAnalyze/aiRecommend/data';
import { MyPatternListProps } from '../../../interface/aiAnalyze/aiRecommend/type';

interface Props {
  setIsModalOpen: (value: boolean) => void;
  data: MyPatternListProps[];
  selectedItem: MyPatternListProps;
  setSelectedItem: (value: MyPatternListProps) => void;
}

const PatternListModal = ({
  setIsModalOpen,
  data,
  selectedItem,
  setSelectedItem,
}: Props) => {
  const [checkedItem, setCheckedItem] = useState(data[0]);

  useEffect(() => {
    if (selectedItem.p_idx !== 0) {
      setCheckedItem(selectedItem);
    }
  }, [selectedItem]);
  const ChangeLabelToValue = (value: string, data: any) => {
    const newValue = data.find((item: any) => item.value === value)?.label;
    return newValue ? newValue + ', ' : '';
  };

  const changeCategory = (category: string) => {
    if (category === 'hug') {
      return 'HUG인수조건변경';
    }

    if (category === 'opposing_power') {
      return '임차인 대항력';
    }
    if (category === 'wage_bond') {
      return '임금채권';
    }
    if (category === 'resale') {
      return '재매각';
    }
    if (category === 'violation_building') {
      return '위반건축물';
    }
    if (category === 'statutory_superficies') {
      return '법정지상권';
    }
    if (category === 'tomb_base_right') {
      return '분묘기지권';
    }
    if (category === 'lien') {
      return '유치권';
    }
    return '';
  };

  const ChangeSpecialPatternText = (value: string, category: string) => {
    const Text = changeCategory(category);
    if (value === 'A') {
      return null; // Or return 'N/A' for testing
    }
    if (value === 'Y') {
      return <span>{`${Text}> 선택`}, </span>;
    } else {
      return (
        <>
          <span>{`${Text}> `}</span>
          <span style={{ color: '#F45551' }}>제외</span>,
        </>
      );
    }
  };

  return (
    <Container>
      <Inner>
        <Title>
          <span></span>
          <Title_Text>내 알고리즘 목록</Title_Text>
          <img
            src="/assets/images/close/close-black-14.svg"
            alt=""
            onClick={() => setIsModalOpen(false)}
          />
        </Title>
        <ListBox>
          {data.length > 0 &&
            data.map((item) => (
              <ListItem key={item.p_idx} onClick={() => setCheckedItem(item)}>
                <PatternTextBox>
                  <PatternName>
                    <span>{item.title}</span>
                  </PatternName>
                  <Patterns>
                    <span>
                      {item.ctp}
                      {item.sig === null ? '' : `>${item.sig}`}
                      {item.emd === null ? '' : `>${item.emd}`}
                    </span>
                    , {item.item_category + ', '}
                    <span>
                      {item.start_date.split('T')[0]}~
                      {item.end_date.split('T')[0]}
                      {','}
                    </span>
                    {item.zoning && `${item.zoning}, `}
                    {/* {item.margin !== 'A' && (
                      <span>
                        {item.margin === 'Y'
                          ? `차익有(낙찰가<매각가)`
                          : item.margin === 'N'
                            ? `차익無(낙찰가>매각가)`
                            : ''}
                        ,
                      </span>
                    )}
                    {item.hidden_value !== 'A' && (
                      <span>
                        {item.hidden_value === 'L'
                          ? `저평가 (시세>감정가)`
                          : item.hidden_value === 'H'
                            ? `고평가 (시세<감정가)`
                            : ''}
                        ,
                      </span>
                    )}
                    <span>
                      {item.profit === 'Y'
                        ? '부대비용 포함'
                        : '부대비용 미포함'}
                      ,
                    </span>
                    <span>
                      {ChangeLabelToValue(
                        item.market_prc,
                        MarketPriceEstimationData,
                      )}
                    </span>
                    <span>
                      {ChangeLabelToValue(
                        item.appraisal_point,
                        AppraisalPointData,
                      )}
                    </span>
                    <span>
                      {ChangeLabelToValue(item.bid_cnt, NumberOfFailedBidData)}
                    </span>
                    <span>
                      {ChangeLabelToValue(item.elapsed_years, OldAgeData)}
                    </span>
                    <span>
                      {ChangeLabelToValue(item.sale_days, SalesDaysData)}
                    </span>
                    <span>
                      {item.investment_rate !== null &&
                        `낙찰가의 ${item.investment_rate}%`}
                    </span>
                    {ChangeSpecialPatternText(item.hug, 'hug')}
                    {ChangeSpecialPatternText(
                      item.opposing_power,
                      'opposing_power',
                    )}
                    {ChangeSpecialPatternText(item.wage_bond, 'wage_bond')}
                    {ChangeSpecialPatternText(item.resale, 'resale')}
                    {ChangeSpecialPatternText(
                      item.violation_building,
                      'violation_building',
                    )}
                    {ChangeSpecialPatternText(
                      item.statutory_superficies,
                      'statutory_superficies',
                    )}
                    {ChangeSpecialPatternText(
                      item.tomb_base_right,
                      'tomb_base_right',
                    )}
                    {ChangeSpecialPatternText(item.lien, 'lien')} */}
                  </Patterns>
                </PatternTextBox>
                <img
                  src={`/assets/images/check/circle-checked-${checkedItem.p_idx === item.p_idx ? 'blue' : 'gray'}.svg`}
                  alt=""
                />
              </ListItem>
            ))}
        </ListBox>
        <ModalButtonBox>
          <CancelButton
            onClick={() => {
              setIsModalOpen(false);
            }}
          >
            취소
          </CancelButton>
          <AnalyzeButton
            style={{ flex: 1 }}
            onClick={() => {
              setSelectedItem(checkedItem);
              setIsModalOpen(false);
            }}
          >
            추천 물건보기
          </AnalyzeButton>
        </ModalButtonBox>
      </Inner>
    </Container>
  );
};
export default PatternListModal;

export const NoPatternListModal = ({
  setIsModalOpen,
}: {
  setIsModalOpen: (value: boolean) => void;
}) => {
  const navigate = useNavigate();

  return (
    <Container>
      <Inner>
        <ContentBox>
          <No_Save_Box>
            <No_Save1>저장된 알고리즘이 없어요.</No_Save1>
            <No_Save2>
              3단계로 원하는 조건을 만든 후 빅데이터로 분석하고, 나만의 경매
              성공 공식을 찾아보세요!
            </No_Save2>
          </No_Save_Box>
        </ContentBox>
        <ModalButtonBox>
          <CancelButton
            style={{ width: '114px' }}
            onClick={() => {
              setIsModalOpen(false);
            }}
          >
            닫기
          </CancelButton>
          <AnalyzeButton
            style={{ flex: 1 }}
            onClick={() => {
              setIsModalOpen(false);
              navigate('/myAlgorithm');
            }}
          >
            내 알고리즘 만들기
          </AnalyzeButton>
        </ModalButtonBox>
      </Inner>
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background: #00000080;
`;

const Inner = styled.div`
  width: 100%;
  max-height: 95%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0px -4px 15px 0px #00000040;
  display: flex;
  flex-direction: column;
`;
const Title = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`;

const No_Save_Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 24px 24px 0;
`;

const No_Save1 = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const No_Save2 = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const Title_Text = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #222222;
`;

const ListBox = styled.div`
  width: 100%;
  height: calc(100% - 159px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
`;
const ListItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  border-bottom: 1px solid #e5e8ea;
  justify-content: space-between;
  cursor: pointer;
  padding: 16px 0;
`;
const PatternTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #222;
`;
const PatternName = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
`;
const Count = styled.p`
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
`;

const CountNumber = styled.span`
  color: #008aff;
`;

const Patterns = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
  color: #616161;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const ModalButtonBox = styled.div`
  width: 100%;
  border-top-width: 1px;
  padding-top: 16px;
  padding-right: 16px;
  padding-bottom: 40px;
  padding-left: 16px;
  gap: 8px;
  border-top: 1px solid #e5e8ea;
  display: flex;
  flex-direction: row;
`;
const CancelButton = styled.button`
  padding-top: 12px;
  padding-right: 28px;
  padding-bottom: 12px;
  padding-left: 28px;
  border-radius: 8px;
  background: #70737c14;
  border: none;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
  cursor: pointer;
`;

const AnalyzeButton = styled.button`
  border-radius: 8px;
  padding-top: 12px;
  padding-right: 28px;
  padding-bottom: 12px;
  padding-left: 28px;
  background: #008aff;
  border: none;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
`;

const ContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 16px;
  font-weight: 500;
  color: #616161;
`;
